import { render, staticRenderFns } from "./WorkAreaList.vue?vue&type=template&id=338483b5"
import script from "./WorkAreaList.vue?vue&type=script&lang=js"
export * from "./WorkAreaList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports